import { Inject, Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from './auth.service';
import {Observable, tap} from "rxjs";

@Injectable()
export class AuthGuardService implements CanActivate {
  returnUrl: string;

  constructor(
    public auth: AuthService,
    public router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.auth.isAuthenticatedAsync()
      .pipe(
        tap(isAuth => {
          if(!isAuth) {
            this.auth.logout().subscribe({
              complete: () => {
                this.router.navigate(['/login']);
              }
            });
          }
        })
      );
  }
}
